/**
 * GenUI section icon — same Lucide catalog as flow-builder plan steps (getWorkflowVisual).
 * Callers: InsightsGenuiTiles, InsightsGenuiTable/Bar titles.
 * Schema: optional cell.icon ∈ WORKFLOW_ICON_KEYS; else hint text / kind default.
 * User: "Figure out how they are being provided to the LLM and let's apply them to the answer bento grid."
 */

"use client";

import { getWorkflowVisual } from "@/features/flow-builder/lib/workflow-visual";
import { cn } from "@/shared/lib/utils/cn";

const KIND_DEFAULT_ICON: Record<string, string> = {
  header: "analytics",
  kpi: "revenue",
  table: "spreadsheet",
  bar: "analytics",
  actions: "complete",
  estate: "integration",
  caveat: "alert",
  text: "document",
};

export function GenuiSectionIcon({
  icon,
  hint,
  kind,
  className,
}: {
  icon?: string;
  /** Label/title used when icon missing — same heuristic as plan steps. */
  hint?: string;
  kind?: string;
  className?: string;
}) {
  const style = getWorkflowVisual(
    hint ?? "",
    undefined,
    icon || (kind ? KIND_DEFAULT_ICON[kind] : undefined),
  );
  const Icon = style.icon;
  return (
    <span
      className={cn(
        "mt-0.5 flex size-6 shrink-0 items-center justify-center rounded-lg border",
        style.iconClassName,
        className,
      )}
      aria-hidden
    >
      <Icon className="size-3.5" />
    </span>
  );
}
